import { useState } from "react";
import { authenticateDeploy } from "../api";

const SESSION_KEY = "deploy_authenticated";

export function PasswordGate({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [checking, setChecking] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setChecking(true);
    setError(null);
    try {
      const ok = await authenticateDeploy(password);
      if (ok) {
        sessionStorage.setItem(SESSION_KEY, "1");
        onAuthenticated();
      } else {
        setError("Invalid password");
      }
    } catch {
      setError("Failed to authenticate");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-lg p-8 w-full max-w-sm shadow-sm">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Deploy Dashboard</h2>
        <p className="text-sm text-gray-500 mb-6">Enter the deploy password to continue.</p>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          autoFocus
          className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-gray-900 placeholder-gray-400 focus:outline-none focus:border-indigo-500 mb-3"
        />
        {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
        <button
          type="submit"
          disabled={checking || !password}
          className="w-full px-3 py-2 text-sm font-medium bg-indigo-600 hover:bg-indigo-500 disabled:bg-gray-100 disabled:text-gray-400 text-white rounded-md transition-colors"
        >
          {checking ? "Checking..." : "Continue"}
        </button>
      </form>
    </div>
  );
}

export { SESSION_KEY };
